module.exports = __webpack_public_path__ + "static/media/kids_01.9b468f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_01.jpg
// module id = 5857
// module chunks = 0